import { IClearable } from './../../types/iclearable';
import {
  Component, AfterViewInit, EventEmitter,
  Output, ViewChild, ViewChildren, HostBinding, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { SLLayer } from 'src/app/model/sl-layer';
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';
import { LayersViewComponent } from '../layers-view/layers-view.component';
import { InputBufferLayer } from 'src/app/model/virutal-layers/input-buffer-layer';
import { SLMap } from 'src/app/model/sl-map';

@Component({
  selector: 'app-result-buffer-view',
  templateUrl: './result-buffer-view.component.html',
  styleUrls: ['./result-buffer-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultBufferViewComponent implements AfterViewInit, IClearable {
  public static readonly DEFAULT_LABEL_VALUE = InputBufferLayer.DEFAULT_LABEL_VALUE;

  @ViewChildren('app-toggle-switch') toggleSwitches!: Array<ToggleSwitchComponent>;
  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() ready: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.layer-view') layerView = true;
  @HostBinding('class.work-view') workView = true;
  @HostBinding('class.is-virtual') isVirtual = false;
  @ViewChild('configButton', { static: true }) configButton!: ElementRef;
  @ViewChild('workArea', { static: true }) workArea!: ElementRef;
  @HostBinding('style.max-height') maxHeight = '100%';
  public maxWorkspaceHeight: string | number = 0;

  public layer: InputBufferLayer | null = null;
  @HostBinding('class.layer-edit') hasEditAccess = false;
  @HostBinding('class.layer-read') hasReadAccess = false;
  @HostBinding('class.layer-read-only') hasReadOnlyAccess = false;
  public symbol = '';
  public symbol2 = '';
  public node: any = {};
  public view!: LayersViewComponent;
  public name = 'Buffer Footprint';
  public readOnly = 'false';
  public legendary = false;
  public get queryable(): boolean {
    if (!this.layer) {
      return false;
    }
    if (typeof this.layer.canReplayQuery === 'boolean') {
      return this.layer.canReplayQuery;
    }
    return false;
  }
  public isExpanded = true;
  public labelable = false;
  public labelInfo = {
    labelField: '_sl_override_',
    labelStyleJSON: {
      font: 'RobotoBlack', size: 12, color: '#ffffff',
      align: 'center', outlinecolor: '#000000', outlinewidth: 2, shadowcolor: '#ededed',
      shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 20, position: 'lc'
    },
    inheritLabelStyle: false,
    labelOverride: ResultBufferViewComponent.DEFAULT_LABEL_VALUE,
    override: false,
    labelsOn: true
  };
  public labelStyle: any = {};
  public labelValue = ResultBufferViewComponent.DEFAULT_LABEL_VALUE;
  public showLabelHelp = false;


  // tslint:disable-next-line: variable-name
  public _loaded = false;
  public firstLoad = false;
  public adderName = '';
  public geom = 'point';
  public opacity = 50;
  public opacityEnabled = true;
  public visibility: boolean = false;
  // tslint:disable-next-line:variable-name
  // private _classification: any;
  private settingUp = true;
  public useStyle2 = false;
  private isSetup = false;

  public useStroke1 = false;
  public stroke1 = 'trams';
  public useFill1 = false;
  public fill1 = 'trans';
  public size1 = 2;
  public useStroke2 = false;
  public stroke2 = 'trams';
  public useFill2 = false;
  public fill2 = 'trans';
  public size2 = 2;

  constructor(private changes: ChangeDetectorRef) {
  }
  ngAfterViewInit() {
    this.isSetup = true;
    this.changes.detectChanges();
    window.requestAnimationFrame(() => {
      this.ready.emit({ target: this });
    })

  }

  StyleUpdated(_event: any) {
    this.Apply();
  }
  UpdateHeight(myPanel: any, maxHeight: number | string) {
    myPanel = myPanel;
    const changed = (this.maxHeight !== 'calc(' + maxHeight + 'px - .75em)');
    this.maxHeight = 'calc(' + maxHeight + 'px - .75em)';
    this.maxWorkspaceHeight = 'calc(' + maxHeight + 'px - 6em)';
    this.changes.detectChanges();
    return changed;

  }
  ShowLayer(layer: InputBufferLayer, node: any, view: LayersViewComponent) {
    if (!this.isSetup) {
      setTimeout(() => {
        this.ShowLayer(layer, node, view);
      }, 20)
      return;
    }
    this.labelInfo = layer.GetLabelInfo();
    if (!!this.labelInfo && (
      this.labelInfo.labelOverride === ResultBufferViewComponent.DEFAULT_LABEL_VALUE ||
      this.labelInfo.labelOverride === 'Input Buffer: [value:m:4] meters'
    )) {
      this.labelInfo.labelOverride = layer.GetDefaultLabelOverride();
    }
    this.labelStyle = this.labelInfo.labelStyleJSON;
    this.labelable = this.labelInfo.labelsOn;
    this.firstLoad = true;
    this._loaded = false;
    this.layer = layer;
    this.geom = layer.geom;
    if (Number(this.layer.access) === 1) {
      this.hasReadOnlyAccess = true;
      this.hasReadAccess = true;
    }
    if (Number(this.layer.access) > 1) {
      this.hasReadOnlyAccess = false;
      this.hasReadAccess = true;
      this.hasEditAccess = true;
    }

    this.name = layer.name;
    this.node = node;
    this.view = view;
    this.opacity = layer.opacity * 100;
    this.settingUp = false;
    this.legendary = layer.includeInLegend;
    this.labelValue = this.labelInfo.labelOverride;
    this.symbol = layer.fullClassification[0].symbol;
    this.useFill1 = layer.fullClassification[0].useFill ?? false;

    this.size1 = Number(layer.fullClassification[0].size);
    this.useStyle2 = (layer as InputBufferLayer).useStyle2;
    this.useStroke2 = layer.fullClassification[1].useStroke!;

    this.fill2 = layer.fullClassification[1].fill!;
    this.size2 = Number(layer.fullClassification[1].size);

    this.useStroke1 = layer.fullClassification[0].stroke !== 'trans';
    this.stroke1 = layer.fullClassification[0].stroke!;
    this.fill1 = layer.fullClassification[0].fill!;
    this.useStroke2 = layer.fullClassification[1].stroke !== 'trans';
    this.stroke2 = layer.fullClassification[1].stroke!;
    this.useFill2 = layer.fullClassification[1].useFill!;
    this.symbol2 = layer.fullClassification[1].symbol!;

    this.ToggleVisibility({ value: layer.layerOn === true ? 'true' : 'false' });
    /* if (this.node.hasOwnProperty('footprint')) {
      this.footprint = node.footprint;
    }*/
    this.changes.detectChanges();
    if (this.visibility === true) {
      this.Apply();
    }
    this._loaded = true;
    this.changes.detectChanges();

  }
  Reload() {
    setTimeout(() => this._loaded = false);
    setTimeout(() => {
      this._loaded = true;
      this.changes.detectChanges();
      this.ready.emit({ target: this });
      this.Apply();
    });
  }
  Back() {
    this.back.emit({ layer: this.layer });
  }
  HandleOpacityChange(event: number) {
    this.changes.detectChanges();
    if (this.settingUp === true) { return; }
    if (this.layer) {
      this.layer.opacity = event / 100.0;
    }
    this.changes.detectChanges();
  }
  HandleLegendInclChange(event: any) {
    this.changes.detectChanges();
    if (this.settingUp === true) { return; }
    this.legendary = event.checked;
    if (this.layer) this.layer.includeInLegend = event.checked;
    this.changes.detectChanges();
  }
  ZoomToFeatures() {
    if (this.layer) this.layer.ZoomToFeatures();
  }
  ToggleLabelHelp() {
    this.showLabelHelp = !this.showLabelHelp;
    this.changes.detectChanges();
  }
  Query() {
    if (!this.layer || !this.queryable) {
      return;
    }
    const queryLayer = this.layer as InputBufferLayer & { Query?: () => void };
    if (typeof queryLayer.Query === 'function') {
      queryLayer.Query();
    }
  }
  RefreshLayer() {
    if (!this.layer) return;
    this.layer.ClearImage();
    this.layer.Touch();
    this.layer.Render();

  }
  ToggleVisibility(event: any) {
    this.changes.detectChanges();
    // window.requestAnimationFrame(() => {
    this.visibility = event.value === 'true';
    if (this.layer) {
      this.layer.SetLayerOn(this.visibility,
        this.layer.map as SLMap);
      this.view.UpdateLayerVis(this.layer);
    }
    this.changes.detectChanges();
    // });


  }
  Clear() {
    this.ToggleVisibility({ value: 'false' });

  }
  /* private SetHeight() {
    // this.domNode.nativeElement.style.height = 'calc(' + this.maxHeight + ' - 4.1em)'; // this.maxHeight;
    $(this.workArea.nativeElement).css('height', 'fit-content');
    const workArea = this.workArea.nativeElement;
    $(this.workArea.nativeElement).css('max-height', 'calc(' + this.maxHeight + ' - 5em)');
  } */
  Apply() {
    if (!this.isSetup) {
      return;
    }
    if (!!this.layer) {
      this.changes.detectChanges();
      this.labelInfo.labelStyleJSON = this.labelStyle;
      this.layer.fullClassification[0].useStroke = this.useStroke1;
      this.layer.fullClassification[0].stroke = (this.useStroke1 === true) ? this.stroke1 : 'trans';
      this.layer.fullClassification[0].useFill = this.useFill1;
      this.layer.fullClassification[0].fill = (this.useFill1 === true) ? this.fill1 : 'trans';
      this.layer.fullClassification[0].size = this.size1;
      this.layer.fullClassification[0].symbol = this.symbol;
      (this.layer as InputBufferLayer).useStyle2 = this.useStyle2;
      this.layer.fullClassification[1].useStroke = this.useStroke2;
      this.layer.fullClassification[1].stroke = (this.useStroke2 === true) ? this.stroke2 : 'trans';
      this.layer.fullClassification[1].useFill = this.useFill2;
      this.layer.fullClassification[1].fill = (this.useFill2 === true) ? this.fill2 : 'trans';
      this.layer.fullClassification[1].size = this.size2;
      this.layer.fullClassification[1].symbol = this.symbol2;
      this.layer.SetLabelInfo(this.labelInfo);
      this.layer.Touch(true);
      if (this.visibility === true) {
        this.layer.Render();
      }
      this.layer.UpdateLegend();

    }
  }
  HandleLabelOverrideChange(_val: string) {
    this.changes.detectChanges();
    this.labelInfo.labelOverride = _val;
    this.Apply();
  }
  HandleLabelsOnChange(_event: any) {
    this.changes.detectChanges();
    this.labelInfo.labelsOn = _event.checked;
    this.labelInfo.override = _event.checked;
    this.Apply();
  }


}

